import {
  RECEIPT_TEMPLATES_DATA,
  RECEIPT_TEMPLATES_UPDATED,
  RECEIPT_TEMPLATES_LOADING,
  STORE_USERS_CHANGE,
  DEFAULT_LABEL_PRINT_FORMAT,
  DEFAULT_SKU_GENERATION,
  TRACK_BOX_COLOR,
  TRACK_ROW_COLOR,
  INV_ADJ_MOV
} from '../../constants/ActionTypes'
import { CONFIG_LOGS } from '../../constants/IndexDB_Logs'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES
} from '../../constants/IndexDBData'
import ds from '../../Services/DataServices'
import {
  GetIndexDBDataByTableName,
  saveEntitiesDatatoIndexBD
} from './IndexDBActions'

export function loadReceiptTemplates (isOnline) {
  return dispatch => {
    if (isOnline) getTemplateService(dispatch)
    else getTemplatesFromIndex(dispatch)
  }
}

export function loadReceiptTemplatesUpdated (loadValue) {
  return dispatch => {
    dispatch({ type: RECEIPT_TEMPLATES_UPDATED, payload: loadValue })
  }
}

export function loadReceiptTemplatesLoading (loadValue) {
  return dispatch => {
    dispatch({ type: RECEIPT_TEMPLATES_LOADING, payload: loadValue })
  }
}

export function loadStoreChange (loadValue) {
  return dispatch => {
    dispatch({ type: STORE_USERS_CHANGE, payload: loadValue })
  }
}

export function loadDefaultLabelPrintFormat (loadValue) {
  return dispatch => {
    dispatch({ type: DEFAULT_LABEL_PRINT_FORMAT, payload: loadValue })
  }
}
export function loadDefaultSKUGeneration (loadValue) {
  return dispatch => {
    dispatch({ type: DEFAULT_SKU_GENERATION, payload: loadValue })
  }
}
export function loadTrackBoxColor (loadValue) {
  return dispatch => {
    dispatch({ type: TRACK_BOX_COLOR, payload: loadValue })
  }
}
export function loadTrackRowColor (loadValue) {
  return dispatch => {
    dispatch({ type: TRACK_ROW_COLOR, payload: loadValue })
  }
}

export function loadInvAdjMovement (loadValue) {
  return dispatch => {
    dispatch({ type: INV_ADJ_MOV, payload: loadValue })
  }
}

async function getTemplateService (dispatch) {
  await ds
    .getReceiptTemplatesService({})
    .then(async res => {
      dispatch(loadReceiptTemplatesLoading(false))
      if (res && res.length > 0) {
        dispatch({ type: RECEIPT_TEMPLATES_DATA, payload: res })
        let index_body = {
          config_key: CONFIG_LOGS.RECEP_TEMP,
          data: JSON.stringify(res)
        }
        await saveEntitiesDatatoIndexBD(
          [index_body],
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.CONFIGDATA,
          'getTemplateService'
        )
      }
    })
    .catch(e => {
      dispatch(loadReceiptTemplatesLoading(false))
    })
}

function getTemplatesFromIndex (dispatch) {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.CONFIGDATA
  )
  data
    .then(e => {
      if (e && e.length > 0) {
        dispatch(loadReceiptTemplatesLoading(false))
        const dataExist = e.filter(
          er => er.config_key == CONFIG_LOGS.RECEP_TEMP
        )
        if (dataExist && dataExist.length > 0 && dataExist[0].data) {
          dispatch({
            type: RECEIPT_TEMPLATES_DATA,
            payload: JSON.parse(dataExist[0].data)
          })
        }
      } else {
        console.error(
          'INDEX_DB_DATA_NOT_FOUND -> INDEX_DB_TABLES.CONFIGDATA -->',
          e
        )
      }
    })
    .catch(e => {
      dispatch(loadReceiptTemplatesLoading(false))
      console.error('INDEX_DB_CONFIGS_ERROR -> getTemplatesFromIndex -->', e)
    })
}
